import React from 'react';
import { Grid } from '@material-ui/core';

export const postSecondaryEducationChecklistItems = [
  {
    key: 'secedTakeACTOrAccuplacer',
    label: '15. Take or retake ACT/Accuplacer.',
    confirmKey: 'confirmSecedTakeACTOrAccuplacer',
    points: 3,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
    extra: (act, includesStudent, classes) => (
      <Grid container direction="row" style={{ margin: '0 0 10px 60px' }}>
        <Grid item xs={12} sm={3} md={2} lg={2}>
          <label>ACT Score: {act}</label>
        </Grid>
        <Grid item xs={9} sm={9} md={10} lg={10}>
          {includesStudent && (
            <label className={classes.unprintedContent}>
              <em>*Your ACT score can be entered on the Personal Information page.</em>
            </label>
          )}
        </Grid>
      </Grid>
    ),
  },
  {
    key: 'secedVisitSchools',
    label: '16. Explore and visit colleges/community colleges to which you might want to apply.',
    confirmKey: 'confirmSecedVisitSchools',
    points: 3,
    due: '1st Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedFASID',
    label:
      '17. Go to FAFSA.ed.gov and create a Federal Student Aid Account. (one for you and one for a parent, if applicable.) It may be easiest to have a parent create their FAFSA ID first and then create your FAFSA ID.',
    confirmKey: 'confirmSecedFASID',
    points: 3,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedCompleteFAFSA',
    label: '18. Complete the FAFSA on or after October 1st.',
    confirmKey: 'confirmSecedCompleteFAFSA',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedCollegeApplications',
    label: '19. Submit two or more completed college applications.',
    confirmKey: 'confirmSecedCollegeApplications',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedACTForwarded',
    label: '20. Ensure ACT scores are forwarded to the schools to which you have applied.',
    confirmKey: 'confirmSecedACTForwarded',
    points: 2.5,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedFAFSASent',
    label: '21. Ensure FAFSA information is sent to the schools to which you have applied.',
    confirmKey: 'confirmSecedFAFSASent',
    points: 2.5,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedLocateStudentAidRpt',
    label: '22. Locate the Student Aid Index (SAI) in your email.',
    confirmKey: 'confirmSecedLocateStudentAidRpt',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedStudentAidRpt',
    label: '23. Print Student Aid Index (to be submitted with your Boys Town scholarship application) and keep a copy of it in your senior binder.',
    confirmKey: 'confirmSecedStudentAidRpt',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'seced2ScholarshipApps',
    label: '24. Submit two or more completed college scholarship applications to the school(s) to which you are applying.',
    confirmKey: 'confirmSeced2ScholarshipApps',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedExternalScholarships',
    label: '25. Explore and complete external college scholarship applications (i.e., Buffet Scholarship, GROTC, Goodrich, etc.).',
    confirmKey: 'confirmSecedExternalScholarships',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedAcceptanceLetters',
    label: '26. Gather acceptance letters.',
    confirmKey: 'confirmSecedAcceptanceLetters',
    points: 2,
    due: '2nd Senior Planning Meeting',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedStudentId',
    label: '27. Once accepted, obtain student ID/password used to log into your school account. Store this ID and password in your senior binder.',
    confirmKey: 'confirmSecedStudentId',
    points: 2,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedLogInFinancialAid',
    label: '28. Log into the school account and review financial aid documents. Keep a copy of these documents in your senior binder.',
    confirmKey: 'confirmSecedLogInFinancialAid',
    points: 2,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedLogInOtherDocs',
    label: '29. Log into the school account and check for other documents that need to be submitted to the school.',
    confirmKey: 'confirmSecedLogInOtherDocs',
    points: 2,
    due: 'March',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedCampusHousing',
    label:
      '30. To attend school, you must have a place to live. Finalize your housing options (on campus or off campus) and, if applicable, apply for housing and submit deposts. Keep a copy of the receipts and/or documents in your senior binder.',
    confirmKey: 'confirmSecedCampusHousing',
    points: 2,
    due: 'March - April',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedTranscripts',
    label: '31. Request final transcripts be submitted to the college you are going to attend.',
    confirmKey: 'confirmSecedTranscripts',
    points: 2,
    due: 'May',
    minVersion: 1,
    maxVersion: 1,
  },
  {
    key: 'secedNoteDates',
    label:
      '32. Note the dates for college summer orientation and class registration on your calendar and keep a copy of these dates in your senior binder.',
    confirmKey: 'confirmSecedNoteDates',
    points: 2,
    due: 'May',
    minVersion: 1,
    maxVersion: 1,
  },
];
